<template>
  <div>
    <el-dialog
      title="短信审核"
      :visible="visible"
      width="766px"
      :destroy-on-close="!submitting"
      :before-close="customCloseDrawer"
    >
      <div class="wrap-box" v-loading="dialogLoading">
        <div class="wrap-drawer-header px-4 py-2 mb-4">
          <p>1. 清研公司的短信费用将由财务在年底统一入账到项目中，请填写该项目在清研OA上的项目名称和编号。</p>
          <p>2. 短信费用由【项目经理-多级主管】审核通过后，即可正常发送短信。</p>
          <p>3. 如果短信为自定义短信，短信需第三方平台再次审核后才可正常发送短信。</p>
        </div>
        <div class="sms-text px-4">
          <h2 class="sms-title">短信模版内容</h2>
          <div class="sms-links p-3 text-theme-black-650 leading-5 mt-3">
            {{ examineData.smsContent }}
          </div>
        </div>
        <div class="sms-table px-4 mt-7">
          <h2 class="sms-title">本次发送短信</h2>
          <data-table
            cell-class-name="truncate-table-cell-wrap"
            :data="data"
            :columns="column"
          >
            <template #header_chartNum>
              <span>
                内容字符数<el-tooltip :content="`根据运营商规定，${smsConstantSize}个字符为一条短信，一个汉字和一个字母均占一个字符`" placement="top">
                  <i class="iconfont icon-shuoming text-theme-black-350 cursor-pointer text-medium ml-0.5"></i>
                </el-tooltip>
              </span>
            </template>

          </data-table>
        </div>
        <div class="wrap-drawer-body mt-7">
          <h2 class="sms-title px-4">清研费用审批</h2>
          <div class="drawer-container p-4 box-border overflow-auto">
            <el-form size="small" ref="form" :model="form" :rules="rules" label-width="120px" class="form-container">
              <el-form-item label="项目名称:" prop="projectName">
                <el-input style="width:418px" v-model="form.projectName" placeholder="请输入项目名称" />
              </el-form-item>
              <el-form-item label="项目编号:" prop="projectId">
                <el-input style="width:418px" v-model="form.projectId" placeholder="请输入项目编号" />
              </el-form-item>
              <el-form-item label="所属部门:" prop="departmentName">
                <el-input
                    v-model="form.departmentName"
                    placeholder="请输入"
                    class="w-full"
                    style="width:418px"
                    v-if="deptsType === 0"
                ></el-input>
                <el-select v-else style="width:418px" class="w-full" v-model="form.departmentName" placeholder="请选择所属部门">
                  <el-option v-for="item in deptOptions" :value="item.deptName" :label="item.deptName" :key="item.id"/>
                </el-select>
              </el-form-item>
              <el-form-item label="费用隶属时间:" prop="dateType">
                <el-radio-group v-model="form.dateType">
                  <el-radio label="month">隶属月份</el-radio>
                  <el-radio label="quarter">隶属季度</el-radio>
                </el-radio-group>
                <el-date-picker
                    v-if="form.dateType === 'month'"
                    v-model="form.dateMonth"
                    class="flex"
                    type="month"
                    format="yyyy-MM"
                    value-format="yyyy-MM"
                    placeholder="选择月">
                </el-date-picker>
                <quarter-picker
                    v-else
                    class="flex"
                    style="width: 220px;"
                    placeholder="选择季度"
                    clearable
                    ref="quarterPicker"
                    v-model="form.dateQuarter"
                />
              </el-form-item>
              <el-form-item label="审批人:" prop="auditInfo.auditors">
                <avatar-person
                    :isCheck="false"
                    type="审批"
                    :personList="form.auditInfo.auditors"
                    multiple
                    @add-person="addChoose"
                    @delete-person="removeItem"
                />
                <div class="flex mt-3">
                  <avatar-person
                      :isCheck="true"
                      type="审批"
                      :personList="form.auditInfo.finalAuditor"
                      multiple
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="footer flex justify-end p-4 border-style">
            <el-popover
              v-if="visible"
              placement="top"
              width="208"
              ref="popover"
              trigger="click">
              <div>
                <div class="text-sm">
                  提交后不可修改审批人，确认提交审批吗?
                </div>
                <div class="flex justify-end mt-1">
                  <el-button plain class="text-right" size="mini" :loading="submitting" @click="handleCancel">取消</el-button>
                  <el-button class="text-right" type="primary" size="mini" :loading="submitting" @click="handleSubmit">确定</el-button>
                </div>
              </div>
              <el-button slot="reference" type="primary" :loading="submitting" size="small">提交审批</el-button>
            </el-popover>


          </div>
        </div>
      </div>
    </el-dialog>
    <ChooseExamine :disabled-list="form.auditInfo.finalAuditor" ref="ChooseExamine" @changeStaff="handleChangeStaff" />
  </div>
</template>
<script>
import GlobalConfig, { AuthConfig } from '@/global/config'
import ChooseExamine from '@/views/survey/publish/sms-approve/ChooseExamine.vue'
import DataTable from '@/components/base/DataTable'
import { mapGetters } from 'vuex'
import { getSettleDepts, getSettleDeptStatus } from '@/api/cost-settlement/settlement-initiate/relateProject'
import QuarterPicker from '@/components/base/QuarterPicker.vue'
import { fridayMixins } from '@/mixins/publish'
import { CONSTANT_SMS_SIZE, smsTempStatus } from '@/views/survey/publish/config/sms-sending'
import AvatarPerson from '@/views/home/cost-settlement/settlement-initiate/settle-process/components/AvatarPerson.vue'
import { getSmsFinalAuditors, updateSmsAudit } from '@/api/pay/sms'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    examineData:{
      type: Object,
      default: () => ({})
    }
  },
  mixins:[fridayMixins],
  inject: {
    source: {
      default: () => ({})
    }
  },
  data() {
    return {
      dialogLoading: false,
      smsConstantSize: CONSTANT_SMS_SIZE,
      form: {
        projectName: this.$store.state.survey.title,
        projectId: '',
        departmentName: '',
        dateType: 'month',
        dateMonth: '',
        dateQuarter: [],
        auditInfo:{
          auditors:[],
          finalAuditor:[]
        }
      },
      rules:{
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        projectId: [
          { required: true, message: '请输入项目编号', trigger: 'blur' }
        ],
        departmentName: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        'auditInfo.auditors':[
          { type: 'array', required: true, message: '请至少选择一个审批人', trigger: 'change' }
        ],
        dateType:[
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value==='month') {
                if (!this.form.dateMonth) {
                 return  callback(new Error("请选择费用隶属时间"))
                }
              } else {
                if (!this.form.dateQuarter.length) {
                 return  callback(new Error('请选择费用隶属时间'))
                }
              }
              callback()
            }
          }
        ]
      },
      deptOptions: [],
      data:[],
      column:[
        { value: 'smsQuantity', label: '条数', width: '120' },
        { value: 'smsPerson', label: '收信人数量', width: '120' },
        { value: 'chartNum', label: '内容字符数', width: '120',headName:'header_chartNum' },
        { value: 'smsTotalAmount', label: '短信总金额(元)', width: '120' },

      ],
      deptsType: 0,
      submitting: false
      // visible: false
    }
  },
  computed:{
    ...mapGetters(['title','userInfo']),
  },
  components: {
    AvatarPerson,
    QuarterPicker,
    ChooseExamine,
    DataTable
  },
  methods: {
    customCloseDrawer(){
      this.$emit('update:visible', false)
    },
    handleCancel(){
      console.log('this.$refs.popover',this.$refs.popover)
      this.$refs.popover.doClose()
    },
    handleSubmit(){
      this.$refs.form.validate((valid) =>{
        if (valid) {
          const smsParams = {
            title: this.$store.getters.title,
            timesStr: this.getTimesStr()
          }
          if (this.source.smsCheck === smsTempStatus.COMPANY) {
            smsParams.companyName = GlobalConfig.getCompanyName()
          } else if (this.source.smsCheck === smsTempStatus.HAVE_REWARD) {
            smsParams.money = this.source.smsMoney
          }

          const model = {
            smsTemplateType: this.examineData.smsTemplateType,
            surveyId: GlobalConfig.getSurveyId(),
            smsAmount: "0.1",
            smsParams,
            ...this.data[0],
            ...this.form,
            auditId: this.examineData.id
          }
          if (model.dateType === 'month') model.period = model.dateMonth
          else model.period = model.dateQuarter.join('年-第') + '季度'
          console.log(model)
          this.submitting = true
          updateSmsAudit(model).then(()=>{
            this.$message.success('审批提交成功')
            this.$emit('update:visible', false)
            this.$emit('callBackSuccess',model);
          }).finally(()=>{
            this.submitting = false
          })
        }else{
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除当前审批
    removeItem(item){
      this.form.auditInfo.auditors = this.form.auditInfo.auditors.filter(it=> (it.id !== item.id))
    },
    addChoose(){
      this.$refs.ChooseExamine.visible = true
    },
    handleChangeStaff(val){
      const resultExamineList = [...val,...this.form.auditInfo.auditors]
      this.form.auditInfo.auditors = this.distinct(resultExamineList,'id')
    },
    distinct(list, key) {
      const map = new Map()
      return list.filter((item) => !map.has(item[key].toString()) && map.set(item[key].toString()))
    },
    getDeps(){
      return getSettleDepts().then(res => {
        this.deptOptions = res.data.data
      })
    },
    getSmsFinalAuditors(){
      return getSmsFinalAuditors().then(res=>{
        this.form.auditInfo.finalAuditor = (res.data.data|| []).reduce((cur,item)=>{
          if (item.status !== 1) return
          item.auditorList.forEach(item=>{
            cur.push(item)
          })
          return cur
        },[])
      })
    },
    initSmsTable(){
      const total = this.examineData?.smsPerson || 0
      const billCount = Math.ceil(this.examineData.smsContent.length / CONSTANT_SMS_SIZE)

      this.data= [
        {
          smsQuantity: total * billCount,
          smsPerson:total,
          chartNum: this.examineData.smsContent.length,
          smsTotalAmount: (0.1 * total * billCount).toFixed(2)
        }
      ]
    },
    initForm(){
      this.form.departmentName = this.examineData.departmentName || ''
      this.form.projectId = this.examineData.projectId || ''
      this.form.projectName = this.examineData.projectName || this.$store.getters.title
      const isMonth = !(this.examineData.period || '').includes('季度')
      this.form.dateType = isMonth ? 'month' : 'quarter'

      if (this.form.dateType === 'month') {
        this.form.dateMonth = this.examineData.period
      } else {
        //.join('年-第') + '季度'
        this.form.dateQuarter = (this.examineData.period || '').replace('季度', '').split('年-第')
      }
      if (this.examineData.approveList) {
        let approveList = this.examineData.approveList
        try {
          approveList = JSON.parse(this.examineData.approveList)
        }catch (e) {

        }
        this.form.auditInfo = approveList
      }
    }
  },
  mounted() {
    this.initSmsTable()
    this.initForm()
    this.dialogLoading = true
    Promise.allSettled([ this.getDeps(),this.getSmsFinalAuditors(), getSettleDeptStatus().then(res=>{
      this.deptsType = res.data.data
    })]).finally(()=>{
      this.dialogLoading = false
    })


    // console.log('config.getSurveyTitle()',GlobalConfig.getCompanyName())
    console.log('GlobalConfig.getAuthCode()',GlobalConfig.getAuthCode())
    console.log('isAdmin',this.userInfo.isAdmin)
    console.log('AuthConfig',AuthConfig)

    console.log([AuthConfig.Personal,AuthConfig.PersonalPlus].includes(GlobalConfig.getAuthCode()))
  },
  watch:{
    visible(val){
      if (!val) return
      this.initSmsTable()
    }
  }
}
</script>
<style lang="scss" scoped>
  ::v-deep(.el-dialog__body){
    padding: 0 ;
    color: rgba(0,0,0,1);
  }
  ::v-deep(.el-dialog__header){
    padding: 13px 16px;
  }
  .wrap-drawer-header{
    background: #FFFCEB;
    p{
      color: #e8a31b;
      font-size: 12px;
      line-height: 18px;
    }
  }
  .sms-links{
    background-color: #f5f5f5;
    @apply rounded-small
  }
  .sms-title{
    font-weight: 600;
    font-size: 16px;
  }
  .drawer-container{
    // height: calc(100vh - 115px);
    .form-container{
      .user-img{
        display: block;
        font-style: normal;
        font-weight: normal;
        width: 40px;
        height: 40px;
        background-color: var(--theme-color);
        border-radius: 50%;
        text-align: center;
        line-height: 40px;
        color: #fff;
        font-size: 16px;
        margin-right: 12px;
      }
      .fz-14{
        font-size: 14px;
      }
      .icon-right{
        width: 14px;
        height: 14px;
        // background: url("~@/assets/img/cati/icon-right.png") no-repeat center;
      }
      .add-choose{
        width: 72px;
        height: 68px;
        border-radius: 2px;
        border: 1px solid #2775E8;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        i{
          font-size: 24px;
          color: #2775E8;
        }
        span{
          font-weight: 400;
          font-size: 12px;
          color: #2775E8;
          line-height: 22px;
          margin-top: 4px;
        }
      }
      .task-time-style{
        ::v-deep .el-form-item__label::before{
          content: "*";
          color: #E34152;
          margin-right: 4px;
        }
      }
    }
  }
  .border-style{
    border-top: 1px solid rgba(0,0,0,0.1);
  }
  .wrap-dropdown{
    // padding: 16px;
    padding-bottom: 0px !important;
    .drop-user-img{
      width: 40px;
      height: 40px;
      background-color: var(--theme-color);
      border-radius: 50%;
      text-align: center;
      line-height: 40px;
      color: #fff;
      font-size: 18px;
      margin-right: 12px;
    }
    .user-name-text{
      display: block;
      max-width: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      line-height: 20px;
    }
    .user-name{
      font-size: 16px;
      font-weight: 500;
      max-width: 60px;
      line-height: 16px;
      height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      @apply text-theme-black-850
    }
    .user-dept{
      font-weight: 400;
      font-size: 12px;
      max-width: 60px;
      line-height: 16px;
      height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      @apply text-theme-black-650 ml-2
    }
    .user-phone{
      margin-top: 4px;
      font-weight: 400;
      font-size: 12px;
      line-height: 22px;
      @apply text-theme-black-650
    }
  }
  .el-dropdown{
    .user-name-text{
      text-align: center;
      display: block;
      max-width: 44px;
      margin-top: 2px;
      margin-right: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 20px;
      line-height: 20px;
      height: 20px;
    }
  }
</style>
